export const GOLDEN_YELLOW = `#FFEB60`;
export const BLACK = `#3F3F3F`;
export const TEAL = `#46BCC6`;
export const LIGHT_GRAY = `#F9F9F9`;
export const GRAY = `#DAD8D8`;
export const SKY_BLUE = `#F1FEFF`;
export const ACTIVE_NAV = `#D2F0F3`;

const theme = {
  Button: `
  `,
  Card: `
    border: none;
  `,
  AppLink: `

  `,
  Background: `

  `,
  BodyText: `

  `,
  ExternalLink: `

  `,
  Footer: `

  `,
  Header: `

  `,
  Image: `

  `,
  Input: `

  `,
  LoadingSpinner: `

  `,
  Logo: `

  `,
  PiwikButton: `

  `,
  SubTitle: `

  `,
  Title: `
  `,
  CopyShareButton: `

  `,
  EmailShareButton: `

  `,
  FacebookShareButton: `

  `,
  IconButton: `
    background-color: #C1E7E9;
    height: 1.875rem;
    width: 1.875rem;
    &:hover {
      background-color: #46BCC6;
    }
  `,
  PinterestShareButton: `

  `,
  SocialPageButton: `

  `,
  TwitterShareButton: `

  `,
};


export default theme;
